module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-club-63ca1479.svg";